import { StrictMode } from "react";
import { createRoot } from "react-dom/client";


// Load dayjs plugins once at app boot so .fromNow() / .format("LL") work in
// every card / page that imports dayjs.
import "./lib/dayjs";

import "./App.scss";
import "./index.scss";
import "./styles/global.scss";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { Provider } from "react-redux";
import store from "./store";
import { setUnauthorizedHandler } from "./lib/apiClient";
import { logoutUser } from "./actions/reduxActions/userActions";

import { SiteConfigProvider } from "./contexts/SiteConfigContext";
import { MapsProvider } from "./lib/maps";

// Centralized 401 handler — replaces the old top-level axios interceptor.
setUnauthorizedHandler(() => store.dispatch(logoutUser()));

import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import common_en from "./translations/en/common.json";
import common_urdu from "./translations/urdu/common.json";

const prefLanguage = JSON.parse(window.localStorage.getItem("prefLanguage"));

i18next.init({
  supportedLngs: ["en", "urdu"],
  interpolation: { escapeValue: false },
  lng:
    prefLanguage && (prefLanguage === "en" || prefLanguage === "urdu")
      ? prefLanguage
      : "en",
  fallbackLng: "en",
  resources: {
    en: { common: common_en },
    urdu: { common: common_urdu },
  },
});

const googleClientId =
  import.meta.env?.VITE_GOOGLE_CLIENT_ID ||
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <I18nextProvider i18n={i18next}>
      <GoogleOAuthProvider clientId={googleClientId}>
        <BrowserRouter>
          <Provider store={store}>
            <SiteConfigProvider>
              <MapsProvider>
                <App />
                {/* Single Toaster mount for the whole app (sonner replaces react-alert). */}
                <Toaster position="bottom-center" richColors closeButton />
              </MapsProvider>
            </SiteConfigProvider>
          </Provider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </I18nextProvider>
  </StrictMode>
);
